export default {
  root: {
    class: [
      // Flex
      'flex items-center justify-center',

      // Shape
      'first:rounded-l-2xl',
      'last:rounded-r-2xl',
      'border-y',

      'last:border-r',
      'border-l',
      'border-r-0',

      // Space
      'p-3',

      // Size
      'min-w-[3rem]',

      // Color
      'bg-white dark:bg-surface-800',
      'text-grey dark:text-surface-400',
      'border-dark-grey dark:border-surface-600'
    ]
  }
}
